






















































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import EducationProtocolTableItem from "@/components/education/EducationProtocolTableItem.vue";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import SelectEntity from "@/components/form/SelectEntity.vue";
import {
  Course as ICourse,
  ResourceCategory as IResourceCategory
} from "@/api/models";
import CustomButton from "@/components/form/CustomButton.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import FileManager from "@/components/files/FileManager.vue";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import { laborProtectionApi } from "@/getinfo-api";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import { laborExportModule } from "@/plugins/modules-detect";
import {
  EducationProtocolIdsListParams,
  listIds
} from "@/getinfo-api/education-protocol-ids";
import { chunk as _chunk, uniqBy } from "lodash";
import api from "@/getinfo-api";
import { FileItem as IFileItem } from "@/api/models/file-item";
import { Employee as IEmployee } from "@/api/models/employee";
import protocolsList, {
  EducationProtocolListParams
} from "@/getinfo-api/education-protocol";
import { EducationProtocolShort as IEducationProtocolShort } from "@/api/models/education-protocol-short";
import { LaborExportClass } from "@/services/LaborExportClass";
import { getFileName, FileType } from "@/utils/files-helper";
import { EducationProtocolExportPreChecksMultiplyContractors as IResolveContractor } from "@/api-v2/labor-protection/models/education-protocol-export-pre-checks-multiply-contractors";
import { WorkerImport as IWorkerImport } from "@/api-v2/labor-protection/models/worker-import";
import { EducationProtocolExport as IEducationProtocolExport } from "@/api-v2/labor-protection/models/education-protocol-export";
import LaborResolveContractorForm from "@/components/education/LaborResolveContractorForm.vue";

@Component({
  components: {
    LaborResolveContractorForm,
    FileManager,
    CSingleSelect,
    CBlock,
    CField,
    CPage,
    CustomTable,
    CustomButton,
    EducationProtocolTableItem,
    CustomDatepicker,
    SelectEntity
  }
})
export default class EducationProtocolList extends Vue {
  protocolNumber?: string = undefined;
  course?: ICourse;
  employeeId?: string;
  employees!: Array<IEmployee>;
  categoryId?: string;
  categoryList!: IResourceCategory;
  createdAtMin?: Date = undefined;
  createdAtMax?: Date = undefined;
  gettingResult: boolean = false;
  signedAtMin?: Date = undefined;
  signedAtMax?: Date = undefined;
  signedAt: boolean | undefined;
  order?: "ASC" | "DESC" = "DESC";
  sortedBy: any = "protocolCreatedAt";
  coursesList: CoursesListClass = new CoursesListClass({});
  isXmlLoading: boolean = false;
  xmlFiles: IFileItem[] = [];
  searchedProtocolIds: string[] = [];
  xmlChunkSize: number = 100;
  isLaborProtectionExported?: boolean;
  laborProtectionExportedAtMax?: Date;
  laborProtectionExportedAtMin?: Date;
  isShowCheckboxes: boolean = false;
  selectedProtocolIds: string[] = [];
  isShowFileManagerModal: boolean = false;
  selectedFileForImport?: IFileItem;
  educationProtocols: IEducationProtocolShort[] = [];
  workerImports: IWorkerImport[] = [];
  offset: number = 0;
  itemCount: number = 0;
  preCheckProblems?: IResolveContractor[] = [];
  preCheckDrawerIsVisible: boolean = false;
  laborExportList: IEducationProtocolExport[] = [];

  data() {
    return {
      signedAt: undefined,
      protocolNumber: undefined,
      categoryId: undefined,
      course: undefined,
      employeeId: undefined,
      employees: undefined,
      createdAtMin: undefined,
      createdAtMax: undefined,
      signedAtMin: undefined,
      signedAtMax: undefined,
      isLaborProtectionExported: undefined,
      laborProtectionExportedAtMax: undefined,
      laborProtectionExportedAtMin: undefined,
      selectedFileForImport: undefined,
      categoryList: undefined
    };
  }

  get isShowAdditionalInfoBlock() {
    return this.laborExportList?.length || this.workerImports?.length;
  }

  get laborModuleEnabled() {
    return laborExportModule();
  }

  get companyDiskId() {
    return this.$store.getters.selectedCompany?.diskId;
  }

  get root() {
    return isRoot();
  }

  get currentCompany() {
    return getCurrentCompanyId();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get iconClass() {
    return this.order === "DESC"
      ? "fas fa-long-arrow-alt-down"
      : "fas fa-long-arrow-alt-up";
  }

  setLinkLabel(item: IWorkerImport) {
    return `Импорт от ${this.$converter.date(item.createdAt!)}`;
  }

  _getFileName(file: FileType) {
    return getFileName(file);
  }

  clearSelectedList() {
    this.isShowCheckboxes = false;
    this.selectedProtocolIds = [];
  }

  getCheckedProtocol(protocolId: string) {
    return this.selectedProtocolIds?.includes(protocolId);
  }

  checkedHandler(protocolId: string) {
    if (this.selectedProtocolIds?.includes(protocolId)) {
      this.selectedProtocolIds = this.selectedProtocolIds?.filter(
        el => el !== protocolId
      );
    } else {
      this.selectedProtocolIds = [...this.selectedProtocolIds, protocolId];
    }
  }

  async precheck() {
    try {
      this.preCheckDrawerIsVisible = false;
      this.preCheckProblems = [];
      this.isXmlLoading = true;
      this.preCheckProblems = await LaborExportClass.precheck({
        protocolIds: this.selectedProtocolIds?.length
          ? this.selectedProtocolIds
          : this.searchedProtocolIds,
        path: "",
        companyId: this.currentCompany
      });
      this.preCheckDrawerIsVisible = !!this.preCheckProblems?.length;

      if (!this.preCheckDrawerIsVisible) {
        await this.startExport();
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isXmlLoading = false;
    }
  }

  async startExport(resolvedContractor?: any) {
    try {
      this.preCheckDrawerIsVisible = false;
      this.isXmlLoading = true;

      const form: IEducationProtocolExport = {
        protocolIds: this.selectedProtocolIds?.length
          ? this.selectedProtocolIds
          : this.searchedProtocolIds,
        path: "",
        companyId: this.currentCompany,
        resolveContractors: resolvedContractor ? resolvedContractor : []
      };

      const fileName = this.xmlGeneratedTime();

      const data = await LaborExportClass.startExport(form, fileName);

      this.laborExportList = [...this.laborExportList, data];
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isXmlLoading = false;
    }
  }

  xmlGeneratedTime(): string {
    const hash = (Math.random() + 1).toString(36).substring(7);

    const generatedDate =
      new Date()
        .toLocaleString()
        .split(",")
        .join("")
        .replaceAll(" ", "-")
        .replaceAll(".", "-") + ".xml";

    return hash + "-" + generatedDate;
  }

  sortProtocols(sortType: any) {
    if (this.sortedBy === sortType) {
      if (this.educationProtocols.length < this.itemCount) {
        this.order = this.order === "DESC" ? "ASC" : "DESC";
      } else {
        this.order = this.order === "DESC" ? "ASC" : "DESC";
        this.$store.commit("educationProtocol/REVERSE_LIST");
        return;
      }
    } else {
      this.order = "DESC";
    }
    this.educationProtocols = [];
    this.itemCount = 0;
    this.offset = 0;
    this.sortedBy = sortType;
    this.$store.commit("educationProtocol/CLEAR");
    this.getEducationProtocolList();
  }

  submitSettings() {
    this.educationProtocols = [];
    this.itemCount = 0;
    this.$store.commit("educationProtocol/CLEAR");
    this.getEducationProtocolList();
  }

  async getFileForImport(file: IFileItem & { title: string }) {
    try {
      this.isXmlLoading = true;
      this.selectedFileForImport = file;

      const { data } = await laborProtectionApi.Worker.importWorkers({
        fileId: file.id,
        companyId: this.currentCompany
      });

      this.workerImports = [...this.workerImports, data];
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isXmlLoading = false;
    }
  }

  toggleFileManager() {
    this.isShowFileManagerModal = true;
  }

  async getIds(params?: EducationProtocolIdsListParams) {
    try {
      if (this.laborModuleEnabled) {
        const { data } = await listIds(params!);
        this.searchedProtocolIds = data;
      }
    } catch (e) {
      throw new Error(e);
    }
  }

  fileName(file: FileType) {
    return getFileName(file);
  }

  getCourseCategories() {
    if (this.currentCompany) {
      api.CourseApi.categories(undefined, [this.currentCompany]).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    }
  }

  async xmlGeneratedByChunks() {
    try {
      this.isXmlLoading = true;
      const chunks = _chunk(
        this.selectedProtocolIds?.length
          ? this.selectedProtocolIds
          : this.searchedProtocolIds,
        this.xmlChunkSize
      );
      await Promise.all(
        chunks?.map(async el => {
          const fileName = this.xmlGeneratedTime();
          await this.xmlCreate(el, fileName);
        })
      );
      await this.$store.dispatch("successToast", {
        message: `${this.$tc(this.$translate.Successful)}`
      });
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isXmlLoading = false;
    }
  }

  async xmlCreate(ids: string[], fileName: string) {
    try {
      const { data } = await api.EducationProtocolApi.laborProtectionExport({
        protocolIds: ids,
        diskId: this.companyDiskId,
        path: `Протоколы обучения/Выгрузка в реестр по ОТ/${fileName}`
      });
      this.xmlFiles = [...this.xmlFiles, data];
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
      throw new Error(e);
    }
  }

  showMore() {
    this.offset += 30;
    this.getEducationProtocolList(this.offset);
  }

  async getEducationProtocolList(offset: number = 0) {
    try {
      let params: EducationProtocolListParams = {
        companyId: this.currentCompany ? this.currentCompany : undefined,
        number: this.protocolNumber,
        courseId: this.course?.id,
        protocolCreatedAtMin: this.createdAtMin,
        protocolCreatedAtMax: this.createdAtMax,
        categoryId: this.categoryId,
        signedAt: this.signedAt,
        signedAtMin: this.signedAtMin,
        signedAtMax: this.signedAtMax,
        isLaborProtectionExported: this.isLaborProtectionExported,
        laborProtectionExportedAtMax: this.laborProtectionExportedAtMax,
        laborProtectionExportedAtMin: this.laborProtectionExportedAtMin,
        offset: offset,
        limit: 30,
        sort: this.sortedBy,
        order: this.order
      };
      this.gettingResult = true;
      const { data } = await protocolsList(params);
      this.itemCount = data.count;
      this.educationProtocols = uniqBy(
        [...this.educationProtocols, ...data.items],
        "id"
      );
      await this.getIds(params);
    } finally {
      this.gettingResult = false;
    }
  }

  clearFilter() {
    this.protocolNumber = undefined;
    this.course = undefined;
    this.createdAtMin = undefined;
    this.createdAtMax = undefined;
    this.signedAtMax = undefined;
    this.categoryId = undefined;
    this.signedAtMin = undefined;
    this.signedAt = undefined;
    this.laborProtectionExportedAtMin = undefined;
    this.laborProtectionExportedAtMin = undefined;
    this.isLaborProtectionExported = undefined;
    this.offset = 0;
    this.educationProtocols = [];
    this.itemCount = 0;
    this.submitSettings();
  }

  @Watch("currentCompany")
  updateCompany() {
    this.clearFilter();
    this.coursesList = new CoursesListClass({
      companyIds: [this.currentCompany]
    });
  }

  mounted() {
    this.getCourseCategories();
    this.getEducationProtocolList();
  }
}
